import React from "react";
import { Modal } from "react-bootstrap";
import styles from "../../_css/DeleteUserModal.module.css";
import { CustomButtonDanger, CustomButtonOutlineLight } from "./CustomButtons";

const DeleteUserModal = ({
  show,
  onHide,
  onDelete,
  title,
  message,
  btnText,
  size="sm"
}) => {
  return (
    <Modal show={show} onHide={onHide} centered size={size}>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "20px" }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <div className={styles.iconSection}>
          <div className={styles.iconCircle}>
            <i>
              <img
                width={60}
                src={`${process.env.REACT_APP_PROJECT_URL}/img/delete-icon.png`}
                alt="delete"
              />
            </i>
          </div>
          <div className={styles.title}>{title}</div>
          <div className={styles.message}>{message}</div>
        </div>
        <div
          className={
            styles.buttonRow + " d-flex justify-content-center gap-3 mt-4"
          }
        >
          <CustomButtonOutlineLight
            text="Cancel"
            onClick={onHide}
            width="100%"
          />
          <CustomButtonDanger
            text={btnText}
            onClick={onDelete}
            width="100%"
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteUserModal;
